module.exports = __webpack_public_path__ + "static/media/acu.be167c50.png";